import React from 'react';

import TemplatesContainer from '@totem/components/surveyV2/templates/TemplatesContainer';
import TemplatesTable from '@totem/components/surveyV2/templates/TemplatesTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
const TemplatesPage = () => {
  return (
    <ContentLayout>
      <TemplatesContainer>
        <IBCard isCovered>
          <TemplatesTable />
        </IBCard>
      </TemplatesContainer>
    </ContentLayout>
  );
};

export default TemplatesPage;
